import { clientPortalApi } from 'src/api';
import { AxiosRequestConfig } from 'axios';

export const getCountryCodes = (config: AxiosRequestConfig = {}) =>
  clientPortalApi.get<string[]>('/api/v1/admin-contacts/country-codes', config);
